import moment from 'moment';

const defaultDateFormat = 'YYYY-MM-DD';
const defaultDateTimeFormat = 'YYYY-MM-DD hh:mm:ss';

export const m = {
  date: ({ value, options = {}, callback } = {}) => {
    if (!value) return '';

    const { format = defaultDateFormat } = options;
    const date = moment(value);

    return date.isValid()
      ? callback
        ? callback(date).format(format)
        : date.format(format)
      : '';
  },
  dateTime: ({ value, options = {}, callback } = {}) => {
    if (!value) return '';

    const { format = defaultDateTimeFormat } = options;
    const date = moment(value);

    return date.isValid()
      ? callback
        ? callback(date).format(format)
        : date.format(format)
      : '';
  },
  getToday: ()=>{
    let today = new Date();
    let result = today.getFullYear() + '-' + Number(today.getMonth()+1) + '-' + today.getDate()
    return result
  }
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const formatDate = (value) => { if (!value) return ''; const d = moment(value); return d.isValid() ? d.format(DATE_FORMAT) : ''; };
export const parseDate = (value) => { if (!value) return null; const d = moment(value, DATE_FORMAT, true); if (d.isValid()) return d.toDate(); const loose = moment(value); return loose.isValid() ? loose.toDate() : null; };

export default m;